export enum StaticConfigurationsEnum {
  quotations = 1,
  mcPotential = 2,
  opportunity = 3,
  approveQuotation = 4,
  leads = 5,
  AddOrderOnExpiredContract = 6,
  setOrderBook = 7,
  DisplayInvoiceStatusInInvoiceDetails = 8,
  EnableInvoicesReport = 9,
  EnableService = 10,
  UseSearchInGenerateInvoice = 11,
  HideCustomerCode = 12,
  HideInvoiceStatus = 13,
  HideCollectorName = 14,
  IsOnlinePaymentAvailable = 15,
  EnableSTSOracleIntegration = 20,
    EnableRecieveCall = 21,
  EnableInvoicesDetailesReport = 22,
  DisplayUnitsAndMachinesNos = 30,
  DisplaySales =31,
  EnableRefund=32,
  EnableOrderType=33,
  AlwaysShowContractRenew=34,
  SearchWithMulipleGovernrateAndArea = 35,
  DisplaySTSAndReturnMaterial = 36,
  PrintQuotation=37,
  LimitedUser=38,
  HasTrackingOption=39,
  HasUpdateCustomerCidOption=40,
  IsPrintContractAvaiable=41,
  EnableContractRevenueAllocationReport =42,
  Upayment=45,
  GenerateLinkFromWeb = 48,
  ProfitReport=55,
  HideGuestOrder=56,
  HideInventoryTransactionReport=57,
  CanEditCustomerCID = 60,

  CanEditCustomerCode = 100,
  PgReport = 110,


  SeachByCustomerNameInInvoice=120,
  IsOodoAvailable = 130,
DisplayStockToServiceRequest = 150,
DisplayInvoiceDiscount = 151
}
